const translations = {
  ru: {
    assistant: {
      errorDialog: "Ваша фраза пока не совпадает с оригиналом. Прослушайте аудио и попробуйте ещё раз.",
      errorLessons: "Ваша фраза пока не совпадает с оригиналом. Попробуйте ещё раз.",
      game: {
        intro: "Спасите, помогите! Я скоро зажарюсь! Переводи фразы на табличках, чтобы спасти меня",
        correct: [
          "Фух, мы были в шаге от катастрофы!",
          "Ты лучший!",
          "Вот это знания!",
          "Спасибо, я почти в порядке!",
          "Ты огонь... нет, наоборот!"
        ],
        wrong: [
          "Ай! Это было больно!",
          "Кажется, мне поджарили волосы!",
          "Ты уверен в переводе?",
          "Передай моей семье, что я сгорел на работе!",
          "Зря я пошёл к тебе в помощники!"
        ],
        lowLives: [
          "У меня осталась одна надежда...",
          "Пожалуйста, не сдавайся!",
          "Соберись уже!"
        ],
        fireOut: "Огонь потушен, ты мой герой!",
        criticalLives: ["Это твой последний шанс!", "Сосредоточься, ты сможешь!"],
        highFire: [
          "Отличная работа! Могла бы быть...",
          "Ты собираешься меня сегодня спасать?",
          "Огонь уже рядом!",
          "Не повезло мне с напарником"
        ]
      },
      exam: {
        introWhileCalculating: "Пока считаются результаты, давай немного развлечёмся!",
        timeout: "Подсчёт занял слишком много времени. Попробуйте позже.",
        jokes: [
          "Изучать иностранный язык — это как строить дом: сначала закладываешь фундамент, потом возводишь стены, а потом понимаешь, что забыл дверь.",
          "Почему я не могу понять носителя языка? Потому что он не говорит по слогам и не делает паузы.",
          "Почему люди, говорящие на разных языках, всё равно понимают друг друга в баре? Потому что язык пива универсален.",
          "Самое сложное в изучении иностранного языка — убедить себя, что ты не звучишь как идиот.",
          "Мой уровень иностранного языка? Я понимаю, если говорят медленно, громко и с чётким произношением.",
          "Я учусь говорить по-испански, но пока могу только ругаться и заказывать еду.",
          "Любимая часть изучения языка — когда шутка на нём реально смешная.",
          "Как перестать думать на родном языке? Просто перестать думать вообще."
        ]
      }
    },
    progressbutton: {
      until: "до",
      blablavoice: "BlaBlaVoice",
      description: "35 000 произнесённых фраз — и 3 000 ключевых слов будут приходить на ум мгновенно, покрывая почти всю повседневную речь."
    },	  
	newUserBlock: {
      lesson_neiro: "Выберите тему, нажав на кружок с изображением. Это откроет блок подтем в левом верхнем углу. Надо выбрать одну из них для изучения. В BlaBlaLingo обучение разделено не на уроки, а на соединённые друг с другом темы. Это эффективней и правильней. Чем больше Ваш прогресс по теме, тем ярче картинка в кружочке.",
      dialogs_neiro: "Нажмите на тему, чтобы начать диалог. В BlaBlaLingo обучение разделено не на уроки, а на соединённые друг с другом темы. Это эффективней и правильней. Чем больше Ваш прогресс по теме, тем ярче картинка в кружочке.",
      exam_neiro: "Нажмите на тему, чтобы начать экзамен. Асистент задаст Вам 5 вопросов и оценит Ваш уровень. В BlaBlaLingo обучение разделено не на уроки, а на соединённые друг с другом темы. Это эффективней и правильней. Чем больше раз Вы проходите экзамен по конкретной теме, тем ярче картинка в кружочке.",		
	  dialog: 'Выберите один из вариантов, нажмите и удерживайте кнопку микрофона, прочитайте вслух текст, затем отпустите кнопку.',
	  lesson_vocabulary: 'Просто смотрите на слова и старайтесь их запомнить. Эти слова пригодятся в следующих заданиях.',
	  lesson_matching: 'Соедините пары: выберите слово на русском и найдите его перевод.',
	  lesson_sentence: 'Перетащите слова на правильные места в предложении. Если сложно — нажмите на иконку "Спасательный круг" для подсказки.',
	  lesson_sentence_parallel: 'Всё то же самое, только теперь по три предложения одновременно.',
	  lesson_translate: 'Нажмите кнопку микрофона, произнесите перевод фразы, затем отпустите кнопку.',
	  exam: 'После того как прозвучит вопрос, подумайте и ответьте, удерживая кнопку микрофона. Постарайтесь уложиться в 30 секунд — более длинный ответ не будет обработан.',
	  default: 'Чтобы начать, выберите любую тему в списке ниже 👇',
	  understood: 'Понятно',
	},	  
	referrals: {
	  title: "Реферальная программа",
	  promo: "Приглашайте друзей и получайте <b>10%–20% от их покупок</b> + открывайте бесплатный Premium.",
	  details: "Подробности акции",
	  loading: "Загрузка...",
	  listTitle: "Ваши приглашённые:",
	  empty: "Пока никто не зарегистрировался.",
	  noEmail: "Без email",
	  error: "Ошибка загрузки рефералов",
	  copied: "Скопировано!",
	  telegram: "Telegram",
	  googlePlay: "Google Play",
	  name: "Имя",
	  platform: "Платформа",
	  date: "Дата регистрации",
	  activity: "Активность",
	  noActivity: "Нет активности",
	  earned_label: "Вы заработали",
	  temp_warning: "Вы используете временный аккаунт. Чтобы воспользоваться преимуществами реферальной программы, зарегистрируйтесь, скачайте App или зайдите через Telegram.",
	  share_text:"Я учу языки с BlaBlaLingo — разговорный тренажёр, который помогает уверенно заговорить за 4–6 месяцев. По моей ссылке дают 7 дней Premium."
	},
    game: {
      chooseDifficulty: "Выберите уровень сложности",
      easy: "Лёгкий",
      medium: "Средний",
      hard: "Сложный",
      victory: "Победа! Ассистент спасён!",
      defeat: "Игра окончена. Ассистент не спасён.",
      complete: "Завершить",
		today: "Сегодня",
		week: "Неделя",
		month: "Месяц",
		top5: "Топ 5 игроков",
		your_results: "Ваши игры",
		bestGame: "Лучшая игра",
		currentGame: "Текущая игра",
		rank: "Место",
		score: "Очки",
		rounds: "Раунды",
		errors: "Ошибки",
		date: "Дата",
		type: "Тип",
		no_data: "Нет данных за выбранный период",
		no_leaderboard: "Нет данных по рейтингу за период",
	  fireSaved: "Ассистент спасён!",
	  complete: "Завершить",
	  gameDuration: "Длительность игры",
	  averagePhraseTime: "Среднее время размышления",
	  sec: "сек.",
	  endGameHint: 'Нажмите, чтобы закончить игру',
	  stepGoalReached: "Вы прошли все фразы этого блока. Завершить игру или продолжить?",
	  continue: "Продолжить"	
    },    
    dialog: {
	  menu: "Выберите тему диалога",	
      dialogFinishedTitle: "Диалог завершен",
      backButton: "Главное меню",
      dialogTopic: "Диалог на тему {topic}. Шаг {current} из {total}",
      historyTitle: "История диалога",
      loading: "Загрузка...",
      error: "Ошибка",
	  start: "Начать!",
      // Можно добавить другие тексты диалога по необходимости
    },	  
    lessons: {
      menu: "Выберите тему урока",
      introTitle: "Твой путь к изучению",
      step1: "Словарь",
      step2: "Сопоставление",
      step3: "Построение фраз. Легко",
      step4: "Построение фраз. Сложно",
      step5: "Устный перевод",
      readyButton: "Я готов",
      autoStart: "Автозапуск через {seconds} сек",
	  progress: "Прогресс"
    },
    vocabularyBlock: {
      delayBetweenPhrases: "Задержка между фразами: {{seconds}} сек"
    },	
    sentenceBlock: {
      all_phrases_are_complete: "Все фразы завершены!",
      play_more: "Ещё",
      next: "Далее",
    },
    translateBlock: {
      processing: "Обработка...",
      audio_not_supported: "Ваше устройство не поддерживает аудиозапись.",
      title: "Переведите: ",
	  progress: "Переведено",
      delay_label: "Задержка перед фразой",
      seconds: "сек.",
      your_translation: "Ваш перевод",
      incorrect_try_again: "Неверно, попробуйте ещё раз.",
      attempts: "Попытки",
    },
    examBlock: {
	  menu: "Готов к экзамену? Выбирай!",	
      title: "Вопрос:",
      progress: "Пройдено",
      processing: "Обработка...",
      audio_not_supported: "Ваше устройство не поддерживает аудиозапись.",
      your_translation: "Ваш перевод",
      incorrect_try_again: "Неверно, попробуйте ещё раз.",
      correct: "Правильно!",
      resultTitle: "Результат экзамена",
      totalScore: "Общий балл",
      question: "Вопрос",
      yourAnswer: "Ваш ответ",
      correctPoints: "Баллы за правильность",
      matchPoints: "Баллы за соответствие",
      errors: "Ошибки",
      advice: "Совет",
      prev: "Назад",
      next: "Далее",      
      finishExam: "Завершить экзамен",
	  limitTitle: "Лимит экзаменов",
	  limitText: "Вы прошли {examsToday} из {examLimit} доступных экзаменов сегодня.\nПриходите завтра!",
	  limitButton: "Ок, понял",
	  limitUpgradeNote: "Хочешь больше экзаменов? Повышай уровень VIP в настройках!",
	  modalNoticeTitle: "Внимание!",
	  modalNoticeText: "У вас есть результат предыдущего экзамена, который вы не посмотрели. Сейчас мы его покажем.",
	  modalNoticeConfirm: "Показать результат"	  
    },	
	accessDenied: {
	  title: "Доступ ограничен",
	  examTemp: "⏳ Чтобы пройти экзамен, войдите через email, Telegram или установите приложение. Используйте иконки внизу слева.",
	  exam: "⏳ У вас почти закончилось аудио-время для экзамена. Попробуйте другие разделы или активируйте Premium (доступен также в подарок). Время восстанавливается каждые 3 часа!",
	  game: "⏳ Аудио-время для игры на исходе. Переключитесь на другие разделы или получите Premium (доступен также в подарок). Время восполняется каждые 3 часа!",
	  dialog: "⏳ Время аудио-распознавания для диалогов почти на нуле. Вы можете продолжить в других разделах или активировать Premium. Время восстанавливается каждые 3 часа!",
	  backButton: "Вернуться",
	  tempUser: "⚠️ У временных пользователей аудиовремя не восстанавливается автоматически. Чтобы получать полную функциональность, войдите или зарегистрируйтесь. Используйте иконки внизу слева.",
	  default: "⏳ Доступ к этому разделу временно ограничен. Пожалуйста, попробуйте позже."	  
	},
	audioTimeEnded: {
	  title: "Время распознавания истекло",
	  info: "⏳ Время на распознавание аудио закончилось. Вы можете продолжить обучение позже — время восстанавливается каждые 3 часа.\n\nХотите больше возможностей? Активируйте Premium (доступен также в подарок) или используйте раздел «Обучение», который всегда доступен.",
	  backButton: "Назад"
	},
	
	premium: {
	  title: "Premium аккаунт",
	  description: "BlaBlaLingo — это приложение, с которым вы учитесь говорить на иностранном языке. Оно слушает, что вы говорите, и распознаёт вашу речь.\n\nМы называем это <b>временем распознавания</b>.\n\nЧем выше Premium, тем больше времени и тем больше фраз и предложений Вы можете произнести ежедневно!",
	  silver: {
	    title: "Premium Silver",
	    desc: "⏱ Время распознавания увеличено в 2 раза. Длительность 1 месяц."
	  },
	  gold: {
	    title: "Premium Gold",
	    desc: "⏱⏱ Время распознавания увеличено в 3 раза. Длительность 3 месяца."
	  },
	  platinum: {
	    title: "Premium Platinum",
	    desc: "♾️ Время распознавания увеличено в 10 раз, обычный приоритет обработки. Длительность 6 месяцев."
	  },
	  diamond: {
	    title: "Premium Diamond",
	    desc: "♾️⭐ Время распознавания увеличено в 10 раз + приоритетная обработка. Длительность 12 месяцев."
	  },
	  levelInfo: {
		howTo: "Повышайте уровень Premium и зарабатывайте 10%–20%, рекомендуя BlaBlaLingo друзьям:",
		footer: "Получить реферальную ссылку!"
	  },
	  payment_note: '💡 Оплата возможна через Google Play или в Telegram (TON или Stars). Чтобы оплатить в Telegram, свяжите аккаунты Android и Telegram в настройках.',
	  bought: 'куплено'
	},
	settings: {
	  // Заголовки
	  title: "Настройки",
	  mainTab: "Настройки",
	  profileTab: "Профиль",
	  chooseLanguageHint: "Выберите язык",

	  // Поля
	  baseLang: "Базовый язык:",
	  targetLang: "Изучаемый язык:",
	  level: "Уровень:",
	  name: "Ваше имя",
	  avatar: "Аватар",
	  telegram: "Telegram",
	  telegramLinked: "Привязан",
	  linkTelegram: "Привязать",
	  tempWarning: "Вы используете временный аккаунт. Чтобы редактировать профиль, зарегистрируйтесь, скачайте App или зайдите через Telegram.",

	  // Кнопки и статусы
	  save: "Сохранить",
	  saving: "Сохраняем...",
	  success: "Настройки сохранены!",
	  fail: "Ошибка при сохранении",
	  loadFail: "Не удалось загрузить текущие настройки",
	},
    statistics: {
      title: "Статистика",
      loading: "Загрузка...",
      no_data: "Нет данных",
      your_results: "Ваши результаты",
      period: "Период",
      rank: "Место",
      points: "Очки",
      phrases: "Фразы",
      date: "Дата",
      no_chart_data: "Нет данных для графика",
      last_periods: "Последние 10",
      day: "День",
      week: "Неделя",
      month: "Месяц",
      top5: "ТОП-5",
      no_leaderboard: "Нет данных для рейтинга",
      score_legend: "Очки",
      phrases_legend: "Фразы",
      today: "Сегодня",
      this_week: "Эта неделя",
      this_month: "Этот месяц"
    },	
	path: {
      	switchPath: "Path",
      	switchModule: "Modul",
		loading: "Загрузка...",
		empty: "Шаги пути не найдены",
		activeLevel: "В процессе",
		hasProgress: "Есть прогресс",
		notStarted: "Ещё не начато",
		activeRecall: "Active Recall",
		speakingPractice: "развитие речи",
		fallbackTopic: "Тема",
		level_beginner: "Начальный (A1 - A2)",
		level_advanced: "Продвинутый (A2 - B1)",
		level_expert: "Эксперт (B2+)",
		step_learn: "Слова",
		step_easy: "Подсказки",
		step_medium: "Профи",
		milestone_dialog: "Диалог",
		milestone_exam: "Экзамен",
		milestone_review_easy: "С подсказками",
		milestone_review_medium: "Без подсказок",
		milestone_short_dialog: "Д",
		milestone_short_exam: "Э",
		milestone_short_review_easy: "Легко",
		milestone_short_review_medium: "Сложно",
		level_review_eyebrow: "Финал уровня",
		level_review_title: "Закрепление всего уровня",
		level_review_text: "Два финальных прохода по всем словам этого уровня перед переходом дальше.",
		level_review_meta: "Все слова уровня",
		level_review_easy: "С опорой",
		level_review_medium: "Самостоятельно",
		level_review_easy_subtitle: "Все слова уровня с подсказками",
		level_review_medium_subtitle: "Все слова уровня без подсказок",
		lessons_title: "Нулевой (A0 - A1)",
		lessons_subtitle: "Темы и подтемы с короткими уроками для самых первых шагов.",
		lessons_badge: "Lessons",
		lessons_open: "Открыть",
		lessons_start: "Начать",
		lessons_continue: "Продолжить",
		lessons_completed: "Пройдено",
		lessons_progress: "Пройдено подтем",
		lessons_empty: "Уроки не найдены",
		lessons_themes: "Темы",
		lessons_subthemes: "Подтемы",
		lessons_words: "Слова",
		lessons_resume: "Открыть следующую подтему",
		pathLearn_loading: "Загрузка...",
		pathLearn_empty: "Слов больше нет",
		pathLearn_back: "Назад",
		pathLearn_markLearned: "Выучено",
		pathLearn_next: "Далее",
		pathLearn_playWord: "Произнести слово",
		pathLearn_playExample: "Произнести пример",
		pathLearnHintsButton: "Открыть правила",
		pathLearnHintsTitle: "Правила",
		pathLearnHintsMore: "Ещё"
	},
	welcome: {
      title: "Добро пожаловать в BlaBlaLingo!",
	  description: "Хотите заговорить на иностранном? BlaBlaLingo — единственное приложение, где за 150 часов вы произнесёте 35.000 фраз и получите разговорный навык без тысяч $ на курсы и репетиторов!"
	},
	registr: {
		title: "Регистрация по Email",
		email_placeholder: "Введите email",
		password_placeholder: "Введите пароль",
		register: "Зарегистрироваться",
		cancel: "Отмена",
		email_required: "Пожалуйста, введите email",
		invalid_email: "Введите корректный email",
		password_required: "Введите пароль",
		password_too_short: "Пароль должен быть не менее 6 символов",
		login: "Вход",
	},
	registrationButtons: {
		registrationSuccess: "Письмо для подтверждения отправлено!",
		registrationError: "Ошибка регистрации",
		loginSuccess: "Вход выполнен успешно!",
		loginError: "Ошибка входа",
		checkSpam: 'Не забудьте проверить папку SPAM',
	},	
	menu: {
      dialog: "Диалоги",
      play: "Играть",
      exam: "Экзамен",
      learn: "Обучение",
	  press: 'Нажмите на кружок',
	  choice: 'Выберите уровень',
	  testSimple: "Вопрос/Ответ",
	  lockNote: "Доступно после 2 000 фраз",
	  levelLocked: "Уровни доступны для владельцев тарифа All Inclusive",
      buyPremium: "Купить Premium",
      modalTitle: "Внимание",
	  auxModules: "Вспомогательные модули"
    },
	neirotopic: {
      reselect: "Перевыбрать",
      press_random: "или нажмите Random"
    },
    logomail: {
	  tempuser: "Зарегистрируйтесь по email, скачайте приложение или используйте Telegram, чтобы иметь доступ к полному функционалу",
      messages: "Сообщения",
      achievements: "Достижения",
      markAsRead: "Прочитать",
      noMessages: "Нет сообщений",
      achievement1: "Завершено 10 уроков",
      achievement2: "Получен уровень A2",
      achievement3: "Приглашено 5 друзей"
    },
	achievements: {
	  // Заголовки
	  titleBlaBlaVoice: "🔊 BlaBlaVoice",
	  titleUnstoppable: "📅 Неудержимый",
	  titleBetterEveryDay: "🚀 С каждым днём лучше",
	  titleStreaksByCount: "🔥 Дни с N+ фраз подряд",
	  titleAmbassador: "🤝 Амбассадор BlaBlaLingo",

	  // Подписи
	  labelSpokenPhrases: "Произнесённые фразы",
	  labelStreak: "Дни подряд",
	  labelBeatYourself: "Дней превзошёл себя",
	  labelReferrals: "Приглашённые активные друзья",
		
	  nextLevel: "Следующий уровень:",
	  allLevelsCompleted: "Все уровни достигнуты! 🎉",
	  

	  // Описания
	  descBlaBlaVoice: "Измеряет ваш общий прогресс в произношении фраз. Каждый уровень открывает новое звание от BlaBlaNoob до BlaBlaGod!",
	  descUnstoppable: "Непрерывная активность (сколько дней подряд вы занимаетесь): каждый день тренировок приближает вас к званию легенды постоянства!",
	  descBetterEveryDay: "Показывает, сколько дней подряд вы произносили больше фраз, чем в предыдущий день. Путь к постоянному самосовершенствованию!",
	  descStreaksByCount: "Четыре серии достижений для разных уровней интенсивности. Каждая серия отслеживает количество дней подряд с определённым минимумом фраз.",
	  descAmbassador: "Делитесь BlaBlaLingo с друзьями! Каждый успешно зарегистрированный друг приближает вас к званию главного амбассадора.",

	  // Общие подписи
	  currentLevel: "Текущий уровень",
	  totalProgress: "Общий прогресс: {completed} из {total} уровней",
	  
	  seriesWarmup: "Разогрев (50+)",
	  seriesConfident: "Уверенный (100+)",
	  seriesMaster: "Мастер речи (200+)",
	  seriesNoBrakes: "Без тормозов (300+)"
	},
      payment: {
        heading: 'Оплата',
        price: 'Стоимость',
        methodTitle: 'Доступны способы оплаты:',
		tribute: 'Банковские карты',
		tributeDesc: 'удобная оплата картой через Tribute — ведущий платёжный сервис в Telegram.', 
        ton: 'Оплата TON',
        stars: 'Telegram Stars',
        tonDesc: 'идеально для пользователей, знакомых с криптовалютой. Оплата происходит через TON Wallet или другие кошельки прямо в Telegram.',
        starsDesc: 'внутренняя валюта, которую можно приобрести с помощью локальных платёжных систем.',
        tip: '💡 Совет: через @PremiumBot в веб-версии Telegram можно приобрести звёзды по более выгодной цене.',
        processing: 'Обработка...',
        payTon: (amount) => `Оплатить ${amount} TON`, 
        payStars: (stars) => `Оплатить ${stars} ⭐`,
        statuses: {
          pending: 'Инициализация платежа...',
          confirming: 'Ожидание подтверждения...',
          confirmed: '✅ Платёж подтверждён!',
          sent: '📤 Информация отправлена на сервер',
          timeout: '⏰ Время ожидания истекло',
          error: '❌ Ошибка платежа',
        },
		buy: 'Купить',
		google_play_error: 'Ошибка при оплате через Google Play.',

		  confirm: "Подтвердить",
		  ok: "OK",
		  initErrorTitle: "Ошибка",
		  initError: "Не удалось инициализировать TON Connect. Перезапустите приложение.",
		  confirmStars: (price, name) => `Оплатить ${price} ⭐ за "${name}"?`,
		  processing: "Обработка...",
		  error: "Ошибка",
		  sentTitle: "Транзакция отправлена",
		  sentDesc: "Спасибо за покупку. Ожидайте подтверждение в течение 15 минут.",
		  waitTelegram: "Вы получите уведомление в Telegram боте.",
		  starsError: "Ошибка при создании инвойса.",
		  tonError: "Не удалось отправить TON. Попробуйте позже.",
	
      }	
  },
  en: {
    assistant: {
      errorDialog: "Your phrase does not match the original yet. Please listen to the audio and try again.",
      errorLessons: "Your phrase does not match the original yet. Try again.",
      game: {
        intro: "Help me! I am about to get roasted! Translate the signs to save me!",
        correct: [
          "Phew, we were one step away from disaster!",
          "You are the best!",
          "What a brain!",
          "Thanks, I am almost okay!",
          "You are fire... wait, no, the opposite!"
        ],
        wrong: [
          "Ouch! That hurt!",
          "I think my hair just got singed!",
          "Are you sure about that translation?",
          "Tell my family I burned at work!",
          "I should not have trusted you!"
        ],
        lowLives: [
          "Only one chance left...",
          "Please do not give up!",
          "Focus already!"
        ],
        fireOut: "The fire is out, you are my hero!",
        criticalLives: ["This is your last chance!", "Focus, you can do this!"],
        highFire: [
          "Great job! Could have been...",
          "Are you planning on saving me today?",
          "The fire is almost here!",
          "Tough luck being your partner"
        ]
      },
      exam: {
        introWhileCalculating: "While we calculate your results, let's have some fun!",
        timeout: "This is taking too long. Please try again later.",
        jokes: [
          "Learning a foreign language is like building a house: first foundation, then walls, then you realize you forgot the door.",
          "Why cannot I understand native speakers? They do not speak in syllables with pauses.",
          "Why do people speaking different languages still understand each other in a bar? Beer language is universal.",
          "The hardest part is convincing yourself you do not sound ridiculous.",
          "My level? I understand if they speak slowly, loudly, and clearly.",
          "I am learning Spanish but can only curse and order food so far.",
          "Best moment is when your joke is actually funny, not your accent.",
          "How to stop thinking in your native language? Stop thinking at all."
        ]
      }
    },
    progressbutton: {
      until: "to",
      blablavoice: "BlaBlaVoice",
      description: "35,000 spoken phrases — and 3,000 key words will come to mind instantly, covering almost all everyday speech."
    },	  
	newUserBlock: {
      lesson_neiro: "Select a topic by clicking the image circle. This will open a list of subtopics in the top-left corner. Choose one to study. In BlaBlaLingo, learning is organized by interconnected topics rather than lessons — this is more effective and natural. The more progress you make on a topic, the brighter the image becomes.",
      dialogs_neiro: "Click a topic to start a dialogue. In BlaBlaLingo, learning is based on interconnected topics instead of traditional lessons. This approach is more efficient and natural. The more progress you make on a topic, the brighter the image becomes.",
      exam_neiro: "Click a topic to start the exam. The assistant will ask you 5 questions and assess your level. In BlaBlaLingo, learning is structured around interconnected topics, which is more effective and accurate. The more times you complete an exam on a topic, the brighter the image becomes.",		
	  dialog: 'Choose one of the answers, press and hold the microphone button, read the text aloud, then release the button.',
	  lesson_vocabulary: 'Just look at the words and try to remember them. You’ll need them later in the lesson.',
	  lesson_matching: 'Match the words: select the word in your language and then find its translation.',
	  lesson_sentence: 'Drag the words into the correct order to complete the sentence. Need help? Tap the “Lifebuoy” icon for a hint.',
	  lesson_sentence_parallel: 'Same as before, but now you’ll work with three sentences at once.',
	  lesson_translate: 'Press the microphone, say the translation clearly, then release the button.',
	  exam: 'After the assistant asks a question, think about your answer, press and hold the microphone, speak your answer, and then release. Keep it under 30 seconds — longer recordings won’t be processed.',
	  default: 'To begin, please choose any topic below 👇',
	  understood: 'Got it',
	},  
	referrals: {
	  title: "Referral Program",
	  promo: "Enjoying the app? Share it with friends and get Premium!",
	  details: "Details of the promotion — here.",
	  linkLabel: "Your referral links (choose one depending on where you want to share):",
	  loading: "Loading...",
	  listTitle: "Your referrals:",
	  empty: "No one has registered yet.",
	  noEmail: "No email",
	  error: "Error loading referrals",
	  copied: "Copied!",
	  telegram: "Telegram",
	  googlePlay: "Google Play",
	  name: "Name",
	  platform: "Platform",
	  date: "Registration date",
	  empty: "No one has signed up yet.",
	  activity: "Activity",
	  noActivity: "No activity",
	  earned_label: "You earned",
	  temp_warning: "You are using a temporary account. To enjoy the benefits of the referral program, please register, download the app, or log in via Telegram."
	},	  
    game: {
      chooseDifficulty: "Choose difficulty",
      easy: "Easy",
      medium: "Medium",
      hard: "Hard",
      victory: "Victory! Assistant rescued!",
      defeat: "Game over. Assistant not rescued.",
      complete: "Complete",
		today: "Today",
		week: "Week",
		month: "Month",
		top5: "Top 5 Players",
		your_results: "Your Games",
		bestGame: "Best Game",
		currentGame: "Current Game",
		rank: "Rank",
		score: "Score",
		rounds: "Rounds",
		errors: "Errors",
		date: "Date",
		type: "Type",
		no_data: "No data for selected period",
		no_leaderboard: "No leaderboard data for this period",
	  fireSaved: "The assistant is saved!",
	  complete: "Finish",
	  gameDuration: "Game Duration",
	  averagePhraseTime: "Avg. Thinking Time",
	  sec: "s",
	  endGameHint: 'Click to finish the game',
	  stepGoalReached: "You completed all phrases in this block. Finish the game or continue?",
	  continue: "Continue"		
    },    
    dialog: {
	  menu: "Choose a dialog topic",	
      dialogFinishedTitle: "Dialog finished",
      backButton: "Main menu",
      dialogTopic: "Dialog about {topic}. Step {current} of {total}",
      historyTitle: "Dialog history",
      loading: "Loading...",
      error: "Error",
	  start: "Start!",
    },	  
    lessons: {
      menu: "Choose a lesson topic",
      introTitle: "Your learning journey",
      step1: "Vocabulary",
      step2: "Matching",
      step3: "Phrase building – Easy",
      step4: "Phrase building – Hard",
      step5: "Oral translation",
      readyButton: "I\"m ready",
      autoStart: "Autostart in {seconds} sec",
	  progress: "Progress"	  
    },	
    vocabularyBlock: {
      delayBetweenPhrases: "Delay between phrases: {{seconds}} sec"
    },	
    sentenceBlock: {
      all_phrases_are_complete: "All phrases completed!",
      play_more: "More",
      next: "Next",
    },
    translateBlock: {
      processing: "Processing...",
      audio_not_supported: "Your device does not support audio recording.",
      title: "Translate: ",
	  progress: "Translated",
      delay_label: "Delay before phrase",
      seconds: "sec.",
      your_translation: "Your translation",
      incorrect_try_again: "Incorrect, try again.",
      attempts: "Attempts",
    },
    examBlock: {
	  menu: "Ready for the exam? Choose!",	
      title: "Question:",
      progress: "Completed",
      processing: "Processing...",
      audio_not_supported: "Your device does not support audio recording.",
      your_translation: "Your translation",
      incorrect_try_again: "Incorrect, try again.",
      correct: "Correct!",
      resultTitle: "Exam Result",
      totalScore: "Total Score",
      question: "Question",
      yourAnswer: "Your Answer",
      correctPoints: "Points for Correctness",
      matchPoints: "Points for Match",
      errors: "Errors",
      advice: "Advice",
      prev: "Back",
      next: "Next",         
      finishExam: "Finish Exam",
	  limitTitle: "Exam Limit",
	  limitText: "You have completed {examsToday} out of {examLimit} available exams today.\nCome back tomorrow!",
	  limitButton: "OK, got it",
	  limitUpgradeNote: "Want more exams? Upgrade your VIP level in the settings!",
	  modalNoticeTitle: "Attention!",
      modalNoticeText: "You have a result from the previous exam that you haven't seen yet. We're about to show it.",
      modalNoticeConfirm: "Show result"	  
    },	
	accessDenied: {
	  title: "Access Denied",
	  examTemp: "⏳ To take exams, please sign in via email, Telegram, or install the app. Use the icons in the bottom left corner.",
	  exam: "⏳ Your audio recognition time for the exam is almost used up. Try other sections or get Premium (also available as a gift). Time is restored every 3 hours!",
	  game: "⏳ You`re running low on audio recognition time for the game. Explore other sections or activate Premium (also available as a gift). Time replenishes every 3 hours!",
	  dialog: "⏳ Your audio time for dialog training is almost gone. Switch to other sections or activate Premium. Time restores automatically every 3 hours!",
	  backButton: "Go Back",
	  tempUser: "⚠️ For temporary users, audio time is not replenished automatically. To unlock full functionality, sign in or register. Use the icons at the bottom left.",
	  default: "⏳ Access to this section is temporarily restricted. Please try again later."
	},	
	audioTimeEnded: {
	  title: "Recognition Time Ended",
	  info: "⏳ Your audio recognition time has ended. You can continue later — time restores every 3 hours.\n\nWant more? Activate Premium (also available as a gift) or use the always-available Learning section.",
	  backButton: "Back"
	},
	premium: {
	  title: "Premium Account",
	  description: "BlaBlaLingo is an app that helps you practice speaking a foreign language. It listens to what you say and converts your speech into text.\n\nWe call this <b>recognition time</b>.\n\nThe higher your Premium level, the more time you have to speak and the more phrases and sentences you can say every day!",
		silver: {
		  title: "Premium Silver",
		  desc: "⏱ Recognition time doubled. Duration: 1 month."
		},
		gold: {
		  title: "Premium Gold",
		  desc: "⏱⏱ Recognition time tripled. Duration: 3 months."
		},
		platinum: {
		  title: "Premium Platinum",
		  desc: "♾️ Recognition time increased 10×, standard processing priority. Duration: 6 months."
		},
		diamond: {
		  title: "Premium Diamond",
		  desc: "♾️⭐ Recognition time increased 10× + priority processing. Duration: 12 months."
		},
	  levelInfo: {
		howTo: "You can increase your Premium level when new users sign up using your referral link:",
		footer: "Share your link and unlock new Premium levels!"
	  },
	  payment_note: '💡 Payment is available via Google Play or in Telegram (TON or Stars). To pay via Telegram, link your Android and Telegram accounts in settings.',
	  bought: 'bought'
	},
	settings: {
	  title: "Settings",
	  mainTab: "Settings",
	  profileTab: "Profile",
	  chooseLanguageHint: "Choose language",

	  baseLang: "Base language:",
	  targetLang: "Target language:",
	  level: "Level:",
	  name: "Your name",
	  avatar: "Avatar",
	  telegram: "Telegram",
	  telegramLinked: "Linked",
	  linkTelegram: "Link Telegram",
	  tempWarning: "You are using a temporary account. To edit your profile, please register, download the app, or log in via Telegram.",

	  save: "Save",
	  saving: "Saving...",
	  success: "Settings saved!",
	  fail: "Failed to save settings",
	  loadFail: "Failed to load current settings",
	},
    statistics: {
      title: "Statistics",
      loading: "Loading...",
      no_data: "No data",
      your_results: "Your Results",
      period: "Period",
      rank: "Rank",
      points: "Points",
      phrases: "Phrases",
      date: "Date",
      no_chart_data: "No data for chart",
      last_periods: "Last 10",
      day: "Day",
      week: "Week",
      month: "Month",
      top5: "Top 5",
      no_leaderboard: "No leaderboard data",
      score_legend: "Points",
      phrases_legend: "Phrases",
      today: "Today",
      this_week: "This week",
      this_month: "This month"
    },	
	
    path: {
      switchPath: "Path",
      switchModule: "Modul",
      loading: "Loading...",
      empty: "No path steps found",
      activeLevel: "In progress",
      hasProgress: "Has progress",
      notStarted: "Not started yet",
      activeRecall: "Active Recall",
      speakingPractice: "building speech",
      fallbackTopic: "Topic",
      level_beginner: "Beginner (A1 - A2)",
      level_advanced: "Advanced (A2 - B1)",
      level_expert: "Expert (B2+)",
      step_learn: "Words",
      step_easy: "Hints",
      step_medium: "Profi",
      milestone_dialog: "Dialog",
      milestone_exam: "Exam",
      milestone_review_easy: "With hints",
      milestone_review_medium: "Without hints",
      milestone_short_dialog: "D",
      milestone_short_exam: "E",
      milestone_short_review_easy: "Easy",
      milestone_short_review_medium: "Hard",
      level_review_eyebrow: "Level finale",
      level_review_title: "Consolidate the whole level",
      level_review_text: "Two final passes through all words of this level before moving on.",
      level_review_meta: "All words of the level",
      level_review_easy: "With support",
      level_review_medium: "Solo check",
      level_review_easy_subtitle: "All level words with hints",
      level_review_medium_subtitle: "All level words without hints",
      lessons_title: "Zero Level (A0 - A1)",
      lessons_subtitle: "Topics and subtopics with short lessons for the very first steps.",
      lessons_badge: "Lessons",
      lessons_open: "Open",
      lessons_start: "Start",
      lessons_continue: "Continue",
      lessons_completed: "Completed",
      lessons_progress: "Completed subtopics",
      lessons_empty: "No lessons found",
      lessons_themes: "Themes",
      lessons_subthemes: "Subtopics",
      lessons_words: "Words",
      lessons_resume: "Open next subtopic",
      pathLearn_loading: "Loading...",
      pathLearn_empty: "No words left",
      pathLearn_back: "Back",
      pathLearn_markLearned: "Learned",
      pathLearn_next: "Next",
      pathLearn_playWord: "Play word",
      pathLearn_playExample: "Play example",
      pathLearnHintsButton: "Open grammar rules",
      pathLearnHintsTitle: "Rules",
      pathLearnHintsMore: "More"
    },
welcome: {
	  title: "Welcome to BlaBlaLingo!",
	  description:
		"Want to start speaking a foreign language? BlaBlaLingo is an app where you practice the top 3,000 words + grammar using Retrieval Practice — and build real speaking skills without spending thousands on courses or tutors."
	},
	registr: {
	  title: "Register with Email",
	  email_placeholder: "Enter your email",
	  password_placeholder: "Enter your password",
	  register: "Register",
	  cancel: "Cancel",
	  email_required: "Please enter an email",
	  invalid_email: "Enter a valid email address",
	  password_required: "Please enter a password",
	  password_too_short: "Password must be at least 6 characters",
	  login: "Login",
	},
	registrationButtons: {
		// EN
		registrationSuccess: "Confirmation email has been sent!",
		registrationError: "Registration error",
		loginSuccess: "Login successful!",
		loginError: "Login error",
		checkSpam: "Don't forget to check your SPAM folder",
	},
	menu: {
      dialog: "Dialogs",
	  play: "Play",
      exam: "Exam",
      learn: "Learn",
	  press: 'Tap a circle',
	  choice: 'Choose a level',
	  testSimple: "Question/Answer",
	  lockNote: "Available after 5,000 phrases",
	  levelLocked: "Levels are available only for All Inclusive subscribers",
	  buyPremium: "Buy Premium",
	  modalTitle: "Attention",
	  auxModules: "Auxiliary modules"
    },
    neirotopic: {
      reselect: "Reselect",
      press_random: "or press Random"
    },	
    logomail: {
	  tempuser: "Sign up via email, download the app or use Telegram to access full functionality",	
      messages: "Messages",
      achievements: "Achievements",
      markAsRead: "Mark as Read",
      noMessages: "No messages",
      achievement1: "Completed 10 lessons",
      achievement2: "Achieved A2 level",
      achievement3: "Invited 5 friends"
    },
	achievements: {
	  // Titles
	  titleBlaBlaVoice: "🔊 BlaBlaVoice",
	  titleUnstoppable: "📅 Unstoppable",
	  titleBetterEveryDay: "🚀 Better Every Day",
	  titleStreaksByCount: "🔥 Days in a Row with N+ Phrases",
	  titleAmbassador: "🤝 BlaBlaLingo Ambassador",

	  // Labels
	  labelSpokenPhrases: "Spoken Phrases",
	  labelStreak: "Days in a Row",
	  labelBeatYourself: "Days Beat Yourself",
	  labelReferrals: "Invited active friends",

	  // Descriptions
	  descBlaBlaVoice: "Tracks your total spoken phrase progress. Each level unlocks a new title from BlaBlaNoob to BlaBlaGod!",
	  descUnstoppable: "Consistent activity – every day of training brings you closer to becoming a legend of persistence!",
	  descBetterEveryDay: "Shows how many days in a row you spoke more phrases than the previous day. The path to constant self-improvement!",
	  descStreaksByCount: "Four achievement series for different intensity levels. Each tracks the number of consecutive days with a minimum number of phrases.",
	  descAmbassador: "Share BlaBlaLingo with your friends! Every successful registration brings you closer to becoming the ultimate ambassador.",

		nextLevel: "Next level:",
		allLevelsCompleted: "All levels completed! 🎉",

	  // Common labels
	  currentLevel: "Current Level",
	  totalProgress: "Total progress: {completed} of {total} levels",

	  seriesWarmup: "Warm-up (50+)",
	  seriesConfident: "Confident (100+)",
	  seriesMaster: "Speech Master (200+)",
	  seriesNoBrakes: "No Brakes (300+)"
	},
      payment: {
        heading: 'Payment',
        price: 'Price',
        methodTitle: 'There are payment methods available:',
        ton: 'TON Payment',
        stars: 'Telegram Stars',
        tonDesc: 'Perfect for users familiar with cryptocurrency. Payment is done via TON Wallet or other wallets right in Telegram.',
        starsDesc: 'An internal currency purchasable through local payment methods.',
        tip: '💡 Tip: You can get stars cheaper via @PremiumBot in Telegram Web.',
        processing: 'Processing...',
        payTon: (amount) => `Pay ${amount} TON`,
        payStars: (stars) => `Pay ${stars} ⭐`,
        statuses: {
          pending: 'Initializing payment...',
          confirming: 'Waiting for confirmation...',
          confirmed: '✅ Payment confirmed!',
          sent: '📤 Info sent to server',
          timeout: '⏰ Timeout waiting for confirmation',
          error: '❌ Payment error',
        },
		buy: 'Buy',
		google_play_error: 'Error during Google Play payment.',
		confirm: "Confirm",
		ok: "OK",
		initErrorTitle: "Error",
		initError: "Failed to initialize TON Connect. Please restart the app.",
		confirmStars: (price, name) => `Pay ${price} ⭐ for "${name}"?`,
		processing: "Processing...",
		error: "Error",
		sentTitle: "Transaction Sent",
		sentDesc: "Thank you for your purchase. Confirmation may take up to 15 minutes.",
		waitTelegram: "You will receive a notification in the Telegram bot.",
		starsError: "Error creating the invoice.",
		tonError: "Failed to send TON. Please try again later.",
		
      }	
  },
  de: {
    assistant: {
      errorDialog: "Ihr Satz stimmt noch nicht mit dem Original ueberein. Bitte hoeren Sie das Audio an und versuchen Sie es erneut.",
      errorLessons: "Ihr Satz stimmt noch nicht mit dem Original ueberein. Versuchen Sie es erneut.",
      game: {
        intro: "Hilfe! Ich werde gleich gegrillt! Uebersetze die Schilder, um mich zu retten!",
        correct: [
          "Puh, das war knapp!",
          "Du bist der Beste!",
          "Was fuer ein Wissen!",
          "Danke, ich bin fast okay!",
          "Du bist Feuer... nein, warte!"
        ],
        wrong: [
          "Aua! Das tat weh!",
          "Ich glaube, meine Haare brennen!",
          "Bist du dir mit der Uebersetzung sicher?",
          "Sag meiner Familie, ich bin bei der Arbeit verbrannt!",
          "Warum nur war ich dein Helfer?"
        ],
        lowLives: [
          "Ich habe nur noch eine Hoffnung...",
          "Bitte gib nicht auf!",
          "Konzentration, los!"
        ],
        fireOut: "Feuer geloescht, du bist mein Held!",
        criticalLives: ["Das ist deine letzte Chance!", "Konzentration, du schaffst das!"],
        highFire: [
          "Gute Arbeit! Haette sein koennen...",
          "Hast du heute vor, mich zu retten?",
          "Das Feuer ist fast da!",
          "Ich habe echt Pech mit dir"
        ]
      },
      exam: {
        introWhileCalculating: "Waehrend die Ergebnisse berechnet werden, machen wir ein bisschen Spass!",
        timeout: "Die Auswertung dauert zu lange. Bitte spaeter erneut versuchen.",
        jokes: [
          "Eine Fremdsprache zu lernen ist wie ein Haus zu bauen: Fundament, Waende, und dann fehlt die Tuer.",
          "Warum verstehe ich Muttersprachler nicht? Sie sprechen nicht in Silben mit Pausen.",
          "Warum verstehen sich Leute mit verschiedenen Sprachen in einer Bar? Die Sprache des Bieres ist universal.",
          "Das Schwierigste ist, sich selbst davon zu ueberzeugen, dass man nicht wie ein Idiot klingt.",
          "Mein Niveau? Ich verstehe nur bei langsamem, lautem und deutlichem Sprechen.",
          "Ich lerne Spanisch, kann aber bisher nur fluchen und Essen bestellen.",
          "Die beste Phase ist, wenn dein Witz wirklich lustig ist.",
          "Wie denkt man nicht mehr in der Muttersprache? Einfach gar nicht mehr denken."
        ]
      }
    },
    progressbutton: {
      until: "bis",
      blablavoice: "BlaBlaVoice",
      description: "35.000 gesprochene Sätze – und 3.000 Schlüsselwörter fallen dir sofort ein und decken fast die gesamte Alltagssprache ab."
    },	  
	newUserBlock: {
      lesson_neiro: "Wählen Sie ein Thema, indem Sie auf den Bildkreis klicken. Dadurch wird oben links ein Block mit Unterthemen geöffnet. Wählen Sie eines zum Lernen aus. In BlaBlaLingo ist das Lernen nicht in Lektionen, sondern in miteinander verbundenen Themen organisiert – das ist effektiver und natürlicher. Je mehr Fortschritt Sie bei einem Thema machen, desto heller wird das Bild.",
      dialogs_neiro: "Klicken Sie auf ein Thema, um einen Dialog zu starten. In BlaBlaLingo basiert das Lernen auf miteinander verbundenen Themen statt auf traditionellen Lektionen. Das ist effizienter und natürlicher. Je mehr Fortschritt Sie bei einem Thema machen, desto heller wird das Bild.",
      exam_neiro: "Klicken Sie auf ein Thema, um die Prüfung zu starten. Der Assistent stellt Ihnen 5 Fragen und bewertet Ihr Niveau. In BlaBlaLingo ist das Lernen um miteinander verbundene Themen herum aufgebaut – das ist effektiver und präziser. Je öfter Sie die Prüfung zu einem Thema bestehen, desto heller wird das Bild.",		
	  dialog: 'Wählen Sie eine der Antworten, drücken und halten Sie die Mikrofon-Taste, lesen Sie den Text laut vor und lassen Sie dann die Taste los.',
	  lesson_vocabulary: 'Schauen Sie sich die Wörter an und versuchen Sie, sie sich zu merken. Sie werden sie später brauchen.',
	  lesson_matching: 'Ordnen Sie die Wörter zu: Wählen Sie ein deutsches Wort und finden Sie die passende Übersetzung.',
	  lesson_sentence: 'Ziehen Sie die Wörter in die richtige Reihenfolge, um den Satz zu vervollständigen. Brauchen Sie Hilfe? Tippen Sie auf das Symbol mit dem „Rettungsring“.',
	  lesson_sentence_parallel: 'Wie zuvor, aber diesmal arbeiten Sie mit drei Sätzen gleichzeitig.',
	  lesson_translate: 'Drücken Sie das Mikrofon, sprechen Sie die Übersetzung deutlich, und lassen Sie dann die Taste los.',
	  exam: 'Nachdem der Assistent eine Frage gestellt hat, überlegen Sie sich Ihre Antwort, halten Sie das Mikrofon gedrückt, sprechen Sie, und lassen Sie es dann los. Antworten sollten unter 30 Sekunden lang sein – längere Aufnahmen werden nicht verarbeitet.',
	  default: 'Um zu starten, wählen Sie bitte ein Thema unten 👇',
	  understood: 'Verstanden',
	},	  
	referrals: {
	  title: "Empfehlungsprogramm",
	  promo: "Gefällt dir die App? Teile sie mit Freunden und erhalte Premium!",
	  details: "Details zur Aktion — hier.",
	  linkLabel: "Deine Empfehlungslinks (wähle je nach Plattform, wo du teilen möchtest):",
	  loading: "Wird geladen...",
	  listTitle: "Deine eingeladenen Nutzer:",
	  empty: "Bisher hat sich niemand registriert.",
	  noEmail: "Keine E-Mail",
	  error: "Fehler beim Laden der Empfehlungen",
	  copied: "Kopiert!",
	  telegram: "Telegram",
	  googlePlay: "Google Play",
	  name: "Name",
	  platform: "Plattform",
	  date: "Registrierungsdatum",
	  empty: "Noch hat sich niemand registriert.",
	  activity: "Aktivität",
	  noActivity: "Keine Aktivität", 
	  earned_label: "Du hast verdient",
	  temp_warning: "Sie verwenden ein temporäres Konto. Um von den Vorteilen des Empfehlungsprogramms zu profitieren, registrieren Sie sich, laden Sie die App herunter oder melden Sie sich über Telegram an."
	},	  
    game: {
      chooseDifficulty: "Wähle den Schwierigkeitsgrad",
      easy: "Einfach",
      medium: "Mittel",
      hard: "Schwer",
      victory: "Sieg! Assistent gerettet!",
	  defeat: "Spiel vorbei. Assistent nicht gerettet.",
	  endGameHint: "Klicken, um das Spiel zu beenden",
	  stepGoalReached: "Du hast alle Phrasen dieses Blocks geschafft. Spiel beenden oder weitermachen?",
      complete: "Beenden",
		today: "Heute",
		week: "Woche",
		month: "Monat",
		top5: "Top 5 Spieler",
		your_results: "Deine Spiele",
		bestGame: "Bestes Spiel",
		currentGame: "Aktuelles Spiel",
		rank: "Platz",
		score: "Punkte",
		rounds: "Runden",
		errors: "Fehler",
		date: "Datum",
		type: "Typ",
		no_data: "Keine Daten für den gewählten Zeitraum",
		no_leaderboard: "Keine Rangliste für diesen Zeitraum",
		fireSaved: "Der Assistent ist gerettet!",
		complete: "Beenden",
		gameDuration: "Spielzeit",
		averagePhraseTime: "Durchschnittliche Denkzeit",
		sec: "s",
		continue: "Weitermachen"		
    },    
    dialog: {
	  menu: "Wähle ein Thema",	
      dialogFinishedTitle: "Dialog beendet",
      backButton: "Zurück zur Hauptmenü",
      dialogTopic: "Dialog über {topic}. Schritt {current} von {total}",
      historyTitle: "Dialogverlauf",
      loading: "Wird geladen...",
      error: "Fehler",
	  start: "Start!",
    },	  
    lessons: {
      menu: "Wähle ein Thema",
      introTitle: "Dein Lernweg",
      step1: "Wortschatz",
      step2: "Zuordnung",
      step3: "Satzbau – Einfach",
      step4: "Satzbau – Schwer",
      step5: "Mündliche Übersetzung",
      readyButton: "Ich bin bereit",
      autoStart: "Automatischer Start in {seconds} Sek.",
	  progress: "Fortschritt"	
    },
    vocabularyBlock: {
      delayBetweenPhrases: "Verzögerung zwischen den Sätzen: {{seconds}} Sek"
    },		
    sentenceBlock: {
      all_phrases_are_complete: "Alle Sätze abgeschlossen!",
      play_more: "Mehr",
      next: "Weiter",
    },
    translateBlock: {
      processing: "Verarbeitung...",
      audio_not_supported: "Dein Gerät unterstützt keine Audioaufnahme.",
      title: "Übersetze: ",
	  progress: "Übersetzt",
      delay_label: "Verzögerung vor dem Satz",
      seconds: "Sek.",
      your_translation: "Deine Übersetzung",
      incorrect_try_again: "Falsch, versuch es nochmal.",
      attempts: "Versuche",
    },
    examBlock: {
	  menu: "Bereit für die Prüfung? Wählen!",		
      title: "Frage:",
      progress: "Abgeschlossen",
      processing: "Verarbeitung...",
      audio_not_supported: "Ihr Gerät unterstützt keine Audioaufnahme.",
      your_translation: "Ihre Übersetzung",
      incorrect_try_again: "Falsch, bitte versuche es erneut.",
      correct: "Richtig!",
      resultTitle: "Prüfungsergebnis",
      totalScore: "Gesamtpunktzahl",
      question: "Frage",
      yourAnswer: "Deine Antwort",
      correctPoints: "Punkte für Richtigkeit",
      matchPoints: "Punkte für Übereinstimmung",
      errors: "Fehler",
      advice: "Hinweis",
      prev: "Zurück",
      next: "Weiter",      
      finishExam: "Prüfung beenden",
	  limitTitle: "Prüfungslimit",
	  limitText: "Du hast heute {examsToday} von {examLimit} möglichen Prüfungen abgeschlossen.\nKomm morgen wieder!",
	  limitButton: "Alles klar",
	  limitUpgradeNote: "Willst du mehr Prüfungen? Erhöhe dein VIP-Level in den Einstellungen!",
	  modalNoticeTitle: "Achtung!",
      modalNoticeText: "Sie haben ein Ergebnis der vorherigen Prüfung, das Sie noch nicht angesehen haben. Wir zeigen es Ihnen jetzt.",
      modalNoticeConfirm: "Ergebnis anzeigen"
    },	
	premium: {
	  title: "Premium-Konto",
	  description: "BlaBlaLingo ist eine App, mit der Sie das Sprechen in einer Fremdsprache üben können. Die App hört zu, was Sie sagen, und wandelt Ihre Sprache in Text um.\n\nWir nennen das <b>Erkennungszeit</b>.\n\nJe höher Ihr Premium-Level, desto mehr Zeit haben Sie täglich zum Sprechen – und desto mehr Sätze und Redewendungen können erkannt werden!",
		silver: {
		  title: "Premium Silber",
		  desc: "⏱ Erkennungszeit verdoppelt. Laufzeit: 1 Monat."
		},
		gold: {
		  title: "Premium Gold",
		  desc: "⏱⏱ Erkennungszeit verdreifacht. Laufzeit: 3 Monate."
		},
		platinum: {
		  title: "Premium Platin",
		  desc: "♾️ Erkennungszeit 10× erhöht, normale Verarbeitungspriorität. Laufzeit: 6 Monate."
		},
		diamond: {
		  title: "Premium Diamant",
		  desc: "♾️⭐ Erkennungszeit 10× erhöht + bevorzugte Verarbeitung. Laufzeit: 12 Monate."
		},
	  levelInfo: {
		howTo: "Sie können Ihr Premium-Level erhöhen, wenn sich neue Nutzer über Ihren Empfehlungslink registrieren:",
		footer: "Teilen Sie Ihren Link und schalten Sie neue Premium-Stufen frei!"
	  },
	  payment_note: '💡 Zahlung ist über Google Play oder in Telegram (TON oder Stars) möglich. Um in Telegram zu bezahlen, verknüpfen Sie Ihre Android- und Telegram-Konten in den Einstellungen.',
	  bought: 'gekauft'
	},
	accessDenied: {
	  title: "Zugriff verweigert",
	  examTemp: "⏳ Um die Prüfungen zu absolvieren, melde dich per E-Mail, Telegram oder über die App an. Verwende die Symbole unten links.",
	  exam: "⏳ Deine Audiozeit für die Prüfung ist fast aufgebraucht. Nutze andere Bereiche oder aktiviere Premium (auch als Geschenk verfügbar). Die Zeit wird alle 3 Stunden aufgefüllt!",
	  game: "⏳ Deine Audiozeit für das Spiel ist fast aufgebraucht. Wechsle zu anderen Bereichen oder hol dir Premium (auch als Geschenk erhältlich). Die Zeit wird alle 3 Stunden aufgefüllt!",
	  dialog: "⏳ Deine Audiozeit für Dialogtraining ist fast aufgebraucht. Wechsle zu anderen Bereichen oder aktiviere Premium. Die Zeit wird alle 3 Stunden automatisch aufgefüllt!",
	  backButton: "Zurück",
	  tempUser: "⚠️ Bei temporären Nutzern wird die Audiozeit nicht automatisch wiederhergestellt. Um den vollen Funktionsumfang zu nutzen, melde dich bitte an oder registriere dich. Nutze die Symbole unten links.",
	  default: "⏳ Der Zugriff auf diesen Bereich ist vorübergehend eingeschränkt. Bitte versuche es später erneut."
	},
	audioTimeEnded: {
	  title: "Erkennungszeit abgelaufen",
	  info: "⏳ Deine Zeit für die Spracherkennung ist abgelaufen. Du kannst später weitermachen – alle 3 Stunden wird die Zeit automatisch wiederhergestellt.\n\nMöchtest du mehr Möglichkeiten? Aktiviere Premium (auch als Geschenk verfügbar) oder nutze den immer verfügbaren Bereich \"Lernen\".",
	  backButton: "Zurück"
	},	
	settings: {
	  title: "Einstellungen",
	  mainTab: "Einstellungen",
	  profileTab: "Profil",
	  chooseLanguageHint: "Sprache wählen",

	  baseLang: "Basissprache:",
	  targetLang: "Zielsprache:",
	  level: "Niveau:",
	  name: "Dein Name",
	  avatar: "Avatar",
	  telegram: "Telegram",
	  telegramLinked: "Verbunden",
	  linkTelegram: "Telegram verbinden",
	  tempWarning: "Du benutzt ein temporäres Konto. Um dein Profil zu bearbeiten, registriere dich, lade die App herunter oder melde dich über Telegram an.",

	  save: "Speichern",
	  saving: "Speichern...",
	  success: "Einstellungen gespeichert!",
	  fail: "Fehler beim Speichern",
	  loadFail: "Fehler beim Laden der Einstellungen",
	},
    statistics: {
      title: "Statistik",
      loading: "Lädt...",
      no_data: "Keine Daten",
      your_results: "Ihre Ergebnisse",
      period: "Zeitraum",
      rank: "Platz",
      points: "Punkte",
      phrases: "Sätze",
      date: "Datum",
      no_chart_data: "Keine Diagrammdaten",
      last_periods: "Letzte 10",
      day: "Tag",
      week: "Woche",
      month: "Monat",
      top5: "Top 5",
      no_leaderboard: "Keine Ranglistendaten",
      score_legend: "Punkte",
      phrases_legend: "Sätze",
      today: "Heute",
      this_week: "Diese Woche",
      this_month: "Dieser Monat"
    },	
	
    path: {
      switchPath: "Path",
      switchModule: "Modul",
      loading: "L?dt...",
      empty: "Keine Path-Schritte gefunden",
      activeLevel: "Aktiv",
      hasProgress: "Fortschritt vorhanden",
      notStarted: "Noch nicht begonnen",
      activeRecall: "Active Recall",
      speakingPractice: "Sprechen trainieren",
      fallbackTopic: "Thema",
      level_beginner: "Anf?nger (A1 - A2)",
      level_advanced: "Fortgeschritten (A2 - B1)",
      level_expert: "Experte (B2+)",
      step_learn: "W?rter",
      step_easy: "Hinweise",
      step_medium: "Profi",
      milestone_dialog: "Dialog",
      milestone_exam: "Pr?fung",
      milestone_review_easy: "Mit Hinweisen",
      milestone_review_medium: "Ohne Hinweise",
      milestone_short_dialog: "D",
      milestone_short_exam: "E",
      milestone_short_review_easy: "Easy",
      milestone_short_review_medium: "Hard",
      level_review_eyebrow: "Level-Finale",
      level_review_title: "Das ganze Level festigen",
      level_review_text: "Zwei letzte Durchgaenge durch alle Woerter dieses Levels, bevor du weitergehst.",
      level_review_meta: "Alle Woerter des Levels",
      level_review_easy: "Mit Hilfe",
      level_review_medium: "Selbststaendig",
      level_review_easy_subtitle: "Alle Woerter des Levels mit Hinweisen",
      level_review_medium_subtitle: "Alle Woerter des Levels ohne Hinweise",
      lessons_title: "Nullstufe (A0 - A1)",
      lessons_subtitle: "Themen und Unterthemen mit kurzen Lektionen fuer die allerersten Schritte.",
      lessons_badge: "Lessons",
      lessons_open: "Oeffnen",
      lessons_start: "Starten",
      lessons_continue: "Weiter",
      lessons_completed: "Abgeschlossen",
      lessons_progress: "Abgeschlossene Unterthemen",
      lessons_empty: "Keine Lektionen gefunden",
      lessons_themes: "Themen",
      lessons_subthemes: "Unterthemen",
      lessons_words: "Woerter",
      lessons_resume: "Naechstes Unterthema oeffnen",
      pathLearn_loading: "L?dt...",
      pathLearn_empty: "Keine W?rter mehr",
      pathLearn_back: "Zur?ck",
      pathLearn_markLearned: "Gelernt",
      pathLearn_next: "Weiter",
      pathLearn_playWord: "Wort abspielen",
      pathLearn_playExample: "Beispiel abspielen",
      pathLearnHintsButton: "Regeln öffnen",
      pathLearnHintsTitle: "Regeln",
      pathLearnHintsMore: "Mehr"
    },
welcome: {
	  title: "Willkommen bei BlaBlaLingo!",
	  description:
		"Möchtest du eine Fremdsprache wirklich sprechen? BlaBlaLingo ist eine App, in der du die Top-3.000 Wörter plus Grammatik mit Retrieval Practice trainierst — und echte Sprechfertigkeit aufbaust, ohne tausende Euro für Kurse oder Nachhilfe auszugeben."
	},
	registr: {
	  title: "Registrierung per E-Mail",
	  email_placeholder: "Geben Sie Ihre E-Mail ein",
	  password_placeholder: "Geben Sie Ihr Passwort ein",
	  register: "Registrieren",
	  cancel: "Abbrechen",
	  email_required: "Bitte E-Mail eingeben",
	  invalid_email: "Gültige E-Mail-Adresse eingeben",
	  password_required: "Bitte Passwort eingeben",
	  password_too_short: "Passwort muss mindestens 6 Zeichen lang sein",
	  login: "Anmelden",
	},
	registrationButtons: {
		// DE
		registrationSuccess: "Bestätigungs-E-Mail wurde gesendet!",
		registrationError: "Registrierungsfehler",
		loginSuccess: "Anmeldung erfolgreich!",
		loginError: "Anmeldefehler",
		checkSpam: "Vergiss nicht, auch den SPAM-Ordner zu überprüfen",
	},
	menu: {
      dialog: "Dialoge",
      play: "Spielen",
      exam: "Prüfung",
      learn: "Lernen",
	  press: 'Tippen Sie auf einen Kreis',
	  choice: 'Wählen Sie ein Niveau',
      testSimple: "Frage/Antwort",
	  lockNote: "Verfügbar nach 5.000 Sätzen",
	  levelLocked: "Die Level sind nur für Inhaber des All-Inclusive-Tarifs verfügbar",
	  buyPremium: "Premium kaufen",
      modalTitle: "Achtung",
	  auxModules: "Zusatzmodule"
    },
    neirotopic: {
      reselect: "Neu auswählen",
      press_random: "oder drücken Sie Random"
    },	
    logomail: {
	  tempuser: "Melden Sie sich per E-Mail an, laden Sie die App herunter oder verwenden Sie Telegram, um auf alle Funktionen zuzugreifen",	
      messages: "Nachrichten",
      achievements: "Erfolge",
      markAsRead: "Als gelesen markieren",
      noMessages: "Keine Nachrichten",
      achievement1: "10 Lektionen abgeschlossen",
      achievement2: "A2-Niveau erreicht",
      achievement3: "5 Freunde eingeladen"
    },
	achievements: {
	  // Titel
	  titleBlaBlaVoice: "🔊 BlaBlaVoice",
	  titleUnstoppable: "📅 Unaufhaltsam",
	  titleBetterEveryDay: "🚀 Jeden Tag besser",
	  titleStreaksByCount: "🔥 Tage in Folge mit N+ Phrasen",
	  titleAmbassador: "🤝 BlaBlaLingo-Botschafter",

	  // Beschriftungen
	  labelSpokenPhrases: "Gesprochene Phrasen",
	  labelStreak: "Tage in Folge",
	  labelBeatYourself: "Tage selbst übertroffen",
	  labelReferrals: "Eingeladene aktive Freunde",

	  // Beschreibungen
	  descBlaBlaVoice: "Verfolgt deinen gesamten Fortschritt beim Sprechen von Phrasen. Jedes Level schaltet einen neuen Titel frei – von BlaBlaNoob bis BlaBlaGod!",
	  descUnstoppable: "Tägliche Aktivität – jeder Trainingstag bringt dich dem Titel einer Beständigkeitslegende näher!",
	  descBetterEveryDay: "Zeigt, wie viele Tage in Folge du mehr Phrasen gesprochen hast als am Vortag. Der Weg zur kontinuierlichen Selbstverbesserung!",
	  descStreaksByCount: "Vier Erfolgsserien für verschiedene Intensitätsstufen. Jede Serie verfolgt die Anzahl der aufeinanderfolgenden Tage mit einem bestimmten Minimum an Phrasen.",
	  descAmbassador: "Teile BlaBlaLingo mit deinen Freunden! Jede erfolgreiche Registrierung bringt dich dem Titel des ultimativen Botschafters näher.",
	  
		nextLevel: "Nächstes Level:",
		allLevelsCompleted: "Alle Levels erreicht! 🎉",
	  

	  // Allgemeine Beschriftungen
	  currentLevel: "Aktuelles Level",
	  totalProgress: "Gesamtfortschritt: {completed} von {total} Leveln",

	  seriesWarmup: "Aufwärmen (50+)",
	  seriesConfident: "Selbstsicher (100+)",
	  seriesMaster: "Sprachmeister (200+)",
	  seriesNoBrakes: "Ohne Bremsen (300+)"
	},
      payment: {
        heading: 'Bezahlung',
        price: 'Preis',
        methodTitle: 'Zahlungsmethoden verfügbar',
        ton: 'TON-Zahlung',
        stars: 'Telegram Stars',
        tonDesc: 'Ideal für Nutzer mit Krypto-Erfahrung. Zahlung über TON Wallet oder andere Wallets direkt in Telegram.',
        starsDesc: 'Interne Währung, die über lokale Zahlungsanbieter gekauft werden kann.',
        tip: '💡 Tipp: Über @PremiumBot in Telegram Web können Stars günstiger gekauft werden.',
        processing: 'Verarbeitung...',
        payTon: (amount) => `${amount} TON bezahlen`,
        payStars: (stars) => `${stars} ⭐ bezahlen`,
        statuses: {
          pending: 'Zahlung wird gestartet...',
          confirming: 'Warten auf Bestätigung...',
          confirmed: '✅ Zahlung bestätigt!',
          sent: '📤 Info an Server gesendet',
          timeout: '⏰ Zeitüberschreitung bei Bestätigung',
          error: '❌ Zahlungsfehler',
        },
		buy: 'Kaufen',
		google_play_error: 'Fehler bei der Zahlung über Google Play.',
		confirm: "Bestätigen",
		ok: "OK",
		initErrorTitle: "Fehler",
		initError: "TON Connect konnte nicht initialisiert werden. Bitte starte die App neu.",
		confirmStars: (price, name) => `Möchtest du ${price} ⭐ für „${name}“ bezahlen?`,
		processing: "Wird verarbeitet...",
		error: "Fehler",
		sentTitle: "Transaktion gesendet",
		sentDesc: "Danke für deinen Kauf. Die Bestätigung kann bis zu 15 Minuten dauern.",
		waitTelegram: "Du erhältst eine Benachrichtigung im Telegram-Bot.",
		starsError: "Fehler beim Erstellen der Rechnung.",
		tonError: "TON konnte nicht gesendet werden. Bitte versuche es später erneut.",
		
      }	
  },
	 uk: {
		assistant: {
		  errorDialog: "Ваша фраза поки не збігається з оригіналом. Прослухайте аудіо і спробуйте ще раз.",
		  errorLessons: "Ваша фраза поки не збігається з оригіналом. Спробуйте ще раз.",
		  game: {
			intro: "Врятуйте, допоможіть! Я скоро згорю! Перекладайте фрази на табличках, щоб врятувати мене",
			correct: [
			  "Фух, ми були на крок від катастрофи!",
			  "Ти найкращий!",
			  "Оце знання!",
			  "Дякую, я майже в порядку!",
			  "Ти вогонь... ні, навпаки!"
			],
			wrong: [
			  "Ай! Це було боляче!",
			  "Здається, мені підсмажили волосся!",
			  "Ти впевнений у перекладі?",
			  "Передай моїй родині, що я згорів на роботі!",
			  "Дарма я пішов до тебе в помічники!"
			],
			lowLives: [
			  "У мене залишилася лише одна надія...",
			  "Будь ласка, не здавайся!",
			  "Зберися вже!"
			],
			fireOut: "Вогонь загашено, ти мій герой!",
			criticalLives: ["Це твій останній шанс!", "Зосередься, ти зможеш!"],
			highFire: [
			  "Відмінна робота! Могло б бути...",
			  "Ти збираєшся сьогодні мене рятувати?",
			  "Вогонь вже поруч!",
			  "Не пощастило мені з напарником"
			]
		  },
		  exam: {
			introWhileCalculating: "Поки підраховуються результати, давай трохи розважимося!",
			timeout: "Підрахунок зайняв надто багато часу. Спробуйте пізніше.",
			jokes: [
			  "Вивчати іноземну мову — це як будувати дім: спочатку фундамент, потім стіни, а потім розумієш, що забув двері.",
			  "Чому я не розумію носія мови? Бо він не говорить по складах і не робить пауз.",
			  "Чому люди з різними мовами все одно розуміють одне одного в барі? Бо мова пива універсальна.",
			  "Найскладніше у вивченні мови — переконати себе, що ти не звучиш як ідіот.",
			  "Мій рівень мови? Розумію, коли говорять повільно, голосно і чітко.",
			  "Вчу іспанську, але поки можу лише лаятися та замовляти їжу.",
			  "Найкраще — коли жарт іноземною справді смішний.",
			  "Як перестати думати рідною мовою? Просто перестати думати взагалі."
			]
		  }
		},
		progressbutton: {
		  until: "до",
		  blablavoice: "BlaBlaVoice",
		  description: "35 000 вимовлених фраз — і 3 000 ключових слів будуть миттєво приходити на думку, покриваючи майже всю повсякденну мову."
		},	  
		newUserBlock: {
		  lesson_neiro: "Оберіть тему, натиснувши на кружечок із зображенням. Це відкриє блок підтематик у лівому верхньому куті. Потрібно обрати одну з них для вивчення. У BlaBlaLingo навчання поділено не на уроки, а на з’єднані між собою теми. Це ефективніше й правильніше. Чим більший ваш прогрес за темою, тим яскравіше зображення в кружечку.",
		  dialogs_neiro: "Натисніть на тему, щоб почати діалог. У BlaBlaLingo навчання поділено не на уроки, а на з’єднані між собою теми. Це ефективніше й правильніше. Чим більший ваш прогрес за темою, тим яскравіше зображення в кружечку.",
		  exam_neiro: "Натисніть на тему, щоб почати іспит. Асистент поставить вам 5 запитань і оцінить ваш рівень. У BlaBlaLingo навчання поділено не на уроки, а на з’єднані між собою теми. Це ефективніше й правильніше. Чим більше разів ви проходите іспит з конкретної теми, тим яскравіше зображення в кружечку.",		
		  dialog: 'Оберіть один із варіантів, натисніть і утримуйте кнопку мікрофона, прочитайте вголос текст, потім відпустіть кнопку.',
		  lesson_vocabulary: 'Просто дивіться на слова й намагайтеся їх запам’ятати. Ці слова знадобляться в наступних завданнях.',
		  lesson_matching: 'З’єднайте пари: оберіть слово російською та знайдіть його переклад.',
		  lesson_sentence: 'Перетягніть слова на правильні місця в реченні. Якщо складно — натисніть на іконку "Рятувальне коло" для підказки.',
		  lesson_sentence_parallel: 'Усе те саме, тільки тепер по три речення одночасно.',
		  lesson_translate: 'Натисніть кнопку мікрофона, вимовте переклад фрази, потім відпустіть кнопку.',
		  exam: 'Після того як прозвучить запитання, подумайте й відповідайте, утримуючи кнопку мікрофона. Постарайтеся вкластися в 30 секунд — довшу відповідь не буде оброблено.',
		  default: 'Щоб почати, оберіть будь-яку тему в списку нижче 👇',
		  understood: 'Зрозуміло',
		},	  
		referrals: {
			title: "Реферальна програма",
			promo: "Запрошуйте друзів та отримуйте <b>10%–20% від їхніх покупок</b> + відкривайте безкоштовний Premium.",
			details: "Деталі акції",
			loading: "Завантаження...",
			listTitle: "Ваші запрошені:",
			empty: "Поки ніхто не зареєструвався.",
			noEmail: "Без email",
			error: "Помилка завантаження рефералів",
			copied: "Скопійовано!",
			telegram: "Telegram",
			googlePlay: "Google Play",
			name: "Ім'я",
			platform: "Платформа",
			date: "Дата реєстрації",
			activity: "Активність",
			noActivity: "Немає активності",
			earned_label: "Ви заробили",
			temp_warning: "Ви використовуєте тимчасовий акаунт. Щоб скористатися перевагами реферальної програми, зареєструйтеся, завантажте додаток або увійдіть через Telegram.",
			share_text: "Я вчу мови з BlaBlaLingo — розмовний тренажер, який допомагає впевнено заговорити за 4–6 місяців. За моїм посиланням дають 7 днів Premium."
			},  
		game: {
		  chooseDifficulty: "Оберіть рівень складності",
		  easy: "Легкий",
		  medium: "Середній",
		  hard: "Складний",
		  victory: "Перемога! Асистента врятовано!",
		  defeat: "Гру завершено. Асистента не врятовано.",
		  complete: "Завершити",
			today: "Сьогодні",
			week: "Тиждень",
			month: "Місяць",
			top5: "Топ 5 гравців",
			your_results: "Ваші ігри",
			bestGame: "Найкраща гра",
			currentGame: "Поточна гра",
			rank: "Місце",
			score: "Бали",
			rounds: "Раунди",
			errors: "Помилки",
			date: "Дата",
			type: "Тип",
			no_data: "Немає даних за обраний період",
			no_leaderboard: "Немає даних рейтингу за період",
		  fireSaved: "Асистента врятовано!",
		  complete: "Завершити",
		  gameDuration: "Тривалість гри",
		  averagePhraseTime: "Середній час роздумів",
		  sec: "сек.",
		  endGameHint: 'Натисніть, щоб завершити гру',
		  stepGoalReached: "Ви пройшли всі фрази цього блоку. Завершити гру чи продовжити?",
		  continue: "Продовжити"	
		},    
		dialog: {
		  menu: "Оберіть тему діалогу",	
		  dialogFinishedTitle: "Діалог завершено",
		  backButton: "Головне меню",
		  dialogTopic: "Діалог на тему {topic}. Крок {current} з {total}",
		  historyTitle: "Історія діалогу",
		  loading: "Завантаження...",
		  error: "Помилка",
		  start: "Почати!",
		  // Можна додати інші тексти діалогу за потреби
		},	  
		lessons: {
		  menu: "Оберіть тему уроку",
		  introTitle: "Твій шлях до навчання",
		  step1: "Словник",
		  step2: "Зіставлення",
		  step3: "Побудова фраз. Легко",
		  step4: "Побудова фраз. Складно",
		  step5: "Усний переклад",
		  readyButton: "Я готовий",
		  autoStart: "Автозапуск через {seconds} сек",
		  progress: "Прогрес"
		},
		vocabularyBlock: {
		  delayBetweenPhrases: "Затримка між фразами: {{seconds}} сек"
		},	
		sentenceBlock: {
		  all_phrases_are_complete: "Усі фрази завершено!",
		  play_more: "Ще",
		  next: "Далі",
		},
		translateBlock: {
		  processing: "Обробка...",
		  audio_not_supported: "Ваш пристрій не підтримує аудіозапис.",
		  title: "Перекладіть: ",
		  progress: "Перекладено",
		  delay_label: "Затримка перед фразою",
		  seconds: "сек.",
		  your_translation: "Ваш переклад",
		  incorrect_try_again: "Неправильно, спробуйте ще раз.",
		  attempts: "Спроби",
		},
		examBlock: {
		  menu: "Готовий до іспиту? Обирай!",	
		  title: "Запитання:",
		  progress: "Пройдено",
		  processing: "Обробка...",
		  audio_not_supported: "Ваш пристрій не підтримує аудіозапис.",
		  your_translation: "Ваш переклад",
		  incorrect_try_again: "Неправильно, спробуйте ще раз.",
		  correct: "Правильно!",
		  resultTitle: "Результат іспиту",
		  totalScore: "Загальний бал",
		  question: "Запитання",
		  yourAnswer: "Ваша відповідь",
		  correctPoints: "Бали за правильність",
		  matchPoints: "Бали за відповідність",
		  errors: "Помилки",
		  advice: "Порада",
		  prev: "Назад",
		  next: "Далі",      
		  finishExam: "Завершити іспит",
		  limitTitle: "Ліміт іспитів",
		  limitText: "Ви пройшли {examsToday} з {examLimit} доступних іспитів сьогодні.\nПриходьте завтра!",
		  limitButton: "Ок, зрозуміло",
		  limitUpgradeNote: "Хочеш більше іспитів? Підвищуй рівень VIP у налаштуваннях!",
		  modalNoticeTitle: "Увага!",
		  modalNoticeText: "У вас є результат попереднього іспиту, який ви не переглянули. Зараз ми його покажемо.",
		  modalNoticeConfirm: "Показати результат"	  
		},	
		accessDenied: {
		  title: "Доступ обмежено",
		  examTemp: "⏳ Щоб пройти іспит, увійдіть через email, Telegram або встановіть застосунок. Використовуйте іконки знизу ліворуч.",
		  exam: "⏳ У вас майже закінчився аудіочас для іспиту. Спробуйте інші розділи або активуйте Premium (доступний також у подарунок). Час відновлюється кожні 3 години!",
		  game: "⏳ Аудіочас для гри майже закінчився. Перемкніться на інші розділи або отримайте Premium (доступний також у подарунок). Час відновлюється кожні 3 години!",
		  dialog: "⏳ Час аудіорозпізнавання для діалогів майже на нулі. Ви можете продовжити в інших розділах або активувати Premium. Час відновлюється кожні 3 години!",
		  backButton: "Повернутися",
		  tempUser: "⚠️ У тимчасових користувачів аудіочас не відновлюється автоматично. Щоб отримати повну функціональність, увійдіть або зареєструйтеся. Використовуйте іконки знизу ліворуч.",
		  default: "⏳ Доступ до цього розділу тимчасово обмежено. Будь ласка, спробуйте пізніше."	  
		},
		audioTimeEnded: {
		  title: "Час розпізнавання вичерпано",
		  info: "⏳ Час на розпізнавання аудіо закінчився. Ви можете продовжити навчання пізніше — час відновлюється кожні 3 години.\n\nХочете більше можливостей? Активуйте Premium (доступний також у подарунок) або скористайтеся розділом «Навчання», який завжди доступний.",
		  backButton: "Назад"
		},
		
		premium: {
		  title: "Premium акаунт",
		  description: "BlaBlaLingo — це застосунок, з яким ви вчитеся говорити іноземною мовою. Він слухає, що ви говорите, і розпізнає вашу мову.\n\nМи називаємо це <b>часом розпізнавання</b>.\n\nЧим вищий Premium, тим більше часу і тим більше фраз та речень ви можете вимовити щодня!",
		  silver: {
			title: "Premium Silver",
			desc: "⏱ Час розпізнавання збільшено в 2 рази. Тривалість 1 місяць."
		  },
		  gold: {
			title: "Premium Gold",
			desc: "⏱⏱ Час розпізнавання збільшено в 3 рази. Тривалість 3 місяці."
		  },
		  platinum: {
			title: "Premium Platinum",
			desc: "♾️ Час розпізнавання збільшено в 10 разів, звичайний пріоритет обробки. Тривалість 6 місяців."
		  },
		  diamond: {
			title: "Premium Diamond",
			desc: "♾️⭐ Час розпізнавання збільшено в 10 разів + пріоритетна обробка. Тривалість 12 місяців."
		  },
		  levelInfo: {
			howTo: "Підвищуйте рівень Premium та заробляйте 10%–20%, рекомендувавши BlaBlaLingo друзям:",
			footer: "Отримати реферальне посилання!"
		  },
		  payment_note: '💡 Оплата можлива через Google Play або в Telegram (TON або Stars). Щоб оплатити в Telegram, зв’яжіть акаунти Android і Telegram у налаштуваннях.',
		  bought: 'куплено'
		},
		settings: {
		  // Заголовки
		  title: "Налаштування",
		  mainTab: "Налаштування",
		  profileTab: "Профіль",
		  chooseLanguageHint: "Виберіть мову",

		  // Поля
		  baseLang: "Базова мова:",
		  targetLang: "Мова для вивчення:",
		  level: "Рівень:",
		  name: "Ваше ім’я",
		  avatar: "Аватар",
		  telegram: "Telegram",
		  telegramLinked: "Прив’язано",
		  linkTelegram: "Прив’язати",
		  tempWarning: "Ви використовуєте тимчасовий акаунт. Щоб редагувати профіль, зареєструйтеся, завантажте застосунок або зайдіть через Telegram.",

		  // Кнопки і статуси
		  save: "Зберегти",
		  saving: "Зберігаємо...",
		  success: "Налаштування збережено!",
		  fail: "Помилка під час збереження",
		  loadFail: "Не вдалося завантажити поточні налаштування",
		},
		statistics: {
		  title: "Статистика",
		  loading: "Завантаження...",
		  no_data: "Немає даних",
		  your_results: "Ваші результати",
		  period: "Період",
		  rank: "Місце",
		  points: "Бали",
		  phrases: "Фрази",
		  date: "Дата",
		  no_chart_data: "Немає даних для графіка",
		  last_periods: "Останні 10",
		  day: "День",
		  week: "Тиждень",
		  month: "Місяць",
		  top5: "ТОП-5",
		  no_leaderboard: "Немає даних для рейтингу",
		  score_legend: "Бали",
		  phrases_legend: "Фрази",
		  today: "Сьогодні",
		  this_week: "Цей тиждень",
		  this_month: "Цей місяць"
		},	
		
		path: {
			  switchPath: "Path",
			  switchModule: "Modul",
			loading: "Завантаження...",
			empty: "Кроки шляху не знайдено",
			activeLevel: "У процесі",
			hasProgress: "Є прогрес",
			notStarted: "Ще не розпочато",
			activeRecall: "Active Recall",
			speakingPractice: "розвиток мовлення",
			fallbackTopic: "Тема",
			level_beginner: "Початковий (A1 - A2)",
			level_advanced: "Просунутий (A2 - B1)",
			level_expert: "Експерт (B2+)",
			step_learn: "Слова",
			step_easy: "Підказки",
			step_medium: "Профі",
			milestone_dialog: "Діалог",
			milestone_exam: "Іспит",
			milestone_review_easy: "З підказками",
			milestone_review_medium: "Без підказок",
			milestone_short_dialog: "Д",
			milestone_short_exam: "І",
			milestone_short_review_easy: "Легко",
			milestone_short_review_medium: "Складно",
			level_review_eyebrow: "Фінал рівня",
			level_review_title: "Закріплення всього рівня",
			level_review_text: "Два фінальні проходи по всіх словах цього рівня перед переходом далі.",
			level_review_meta: "Усі слова рівня",
			level_review_easy: "З опорою",
			level_review_medium: "Самостійно",
			level_review_easy_subtitle: "Усі слова рівня з підказками",
			level_review_medium_subtitle: "Усі слова рівня без підказок",
			lessons_title: "Нульовий (A0 - A1)",
			lessons_subtitle: "Теми й підтеми з короткими уроками для найперших кроків.",
			lessons_badge: "Lessons",
			lessons_open: "Відкрити",
			lessons_start: "Почати",
			lessons_continue: "Продовжити",
			lessons_completed: "Пройдено",
			lessons_progress: "Пройдено підтем",
			lessons_empty: "Уроки не знайдено",
			lessons_themes: "Теми",
			lessons_subthemes: "Підтеми",
			lessons_words: "Слова",
			lessons_resume: "Відкрити наступну підтему",
			pathLearn_loading: "Завантаження...",
			pathLearn_empty: "Слів більше немає",
			pathLearn_back: "Назад",
			pathLearn_markLearned: "Вивчено",
			pathLearn_next: "Далі",
			pathLearn_playWord: "Відтворити слово",
			pathLearn_playExample: "Відтворити приклад",
			pathLearnHintsButton: "Відкрити правила",
			pathLearnHintsTitle: "Правила",
			pathLearnHintsMore: "Ще"
			},
welcome: {
		  title: "Ласкаво просимо до BlaBlaLingo!",
		  description: "Хочете заговорити іноземною? BlaBlaLingo — єдиний застосунок, де за 150 годин ви вимовите 35 000 фраз і отримаєте розмовну навичку без тисяч $ на курси та репетиторів!"
		},
		  registr: {
			title: "Реєстрація через Email",
			email_placeholder: "Введіть email",
			password_placeholder: "Введіть пароль",
			register: "Зареєструватися",
			cancel: "Скасувати",
			email_required: "Будь ласка, введіть email",
			invalid_email: "Введіть коректний email",
			password_required: "Введіть пароль",
			password_too_short: "Пароль має бути не менше 6 символів",
			login: "Вхід",
		  },
		registrationButtons: {
			registrationSuccess: "Лист для підтвердження надіслано!",
			registrationError: "Помилка реєстрації",
			loginSuccess: "Вхід виконано успішно!",
			loginError: "Помилка входу",
			checkSpam: "Не забудьте перевірити папку SPAM",
		},	
		menu: {
		  dialog: "Діалоги",
		  play: "Грати",
		  exam: "Іспит",
		  learn: "Навчання",
		  press: 'Натисніть на кружечок',
		  choice: 'Оберіть рівень',
		  testSimple: "Запитання/Відповідь",
		  lockNote: "Доступно після 2 000 фраз",
		  levelLocked: "Рівні доступні власникам тарифу All Inclusive",
		  buyPremium: "Купити Premium",
		  modalTitle: "Увага",
		  auxModules: "Допоміжні модулі"
		},
		neirotopic: {
		  reselect: "Обрати знову",
		  press_random: "або натисніть Random"
		},
		logomail: {
		  tempuser: "Зареєструйтеся через email, завантажте застосунок або використовуйте Telegram, щоб мати доступ до повного функціоналу",
		  messages: "Повідомлення",
		  achievements: "Досягнення",
		  markAsRead: "Прочитати",
		  noMessages: "Немає повідомлень",
		  achievement1: "Завершено 10 уроків",
		  achievement2: "Отримано рівень A2",
		  achievement3: "Запрошено 5 друзів"
		},
		achievements: {
		  // Заголовки
		  titleBlaBlaVoice: "🔊 BlaBlaVoice",
		  titleUnstoppable: "📅 Невпинний",
		  titleBetterEveryDay: "🚀 Щодня краще",
		  titleStreaksByCount: "🔥 Дні з N+ фраз підряд",
		  titleAmbassador: "🤝 Амбасадор BlaBlaLingo",

		  // Підписи
		  labelSpokenPhrases: "Вимовлені фрази",
		  labelStreak: "Днів поспіль",
		  labelBeatYourself: "Днів перевершив себе",
		  labelReferrals: "Запрошені активні друзі",
			
		  nextLevel: "Наступний рівень:",
		  allLevelsCompleted: "Усі рівні досягнуто! 🎉",
		  
		  // Описи
		  descBlaBlaVoice: "Вимірює ваш загальний прогрес у вимові фраз. Кожен рівень відкриває нове звання від BlaBlaNoob до BlaBlaGod!",
		  descUnstoppable: "Безперервна активність (скільки днів поспіль ви займаєтеся): кожен день тренувань наближає вас до звання легенди наполегливості!",
		  descBetterEveryDay: "Показує, скільки днів поспіль ви вимовляли більше фраз, ніж попереднього дня. Шлях до постійного самовдосконалення!",
		  descStreaksByCount: "Чотири серії досягнень для різних рівнів інтенсивності. Кожна серія відстежує кількість днів поспіль із певним мінімумом фраз.",
		  descAmbassador: "Діліться BlaBlaLingo з друзями! Кожен друг, який успішно зареєструвався, наближає вас до звання головного амбасадора.",

		  // Загальні підписи
		  currentLevel: "Поточний рівень",
		  totalProgress: "Загальний прогрес: {completed} з {total} рівнів",
		  
		  seriesWarmup: "Розігрів (50+)",
		  seriesConfident: "Впевнений (100+)",
		  seriesMaster: "Майстер мовлення (200+)",
		  seriesNoBrakes: "Без гальм (300+)"
		},
		  payment: {
			heading: 'Оплата',
			price: 'Вартість',
			methodTitle: 'Доступні способи оплати:',
			ton: 'Оплата TON',
			stars: 'Telegram Stars',
			tonDesc: 'ідеально для користувачів, знайомих із криптовалютою. Оплата відбувається через TON Wallet або інші гаманці прямо в Telegram.',
			starsDesc: 'внутрішня валюта, яку можна придбати за допомогою локальних платіжних систем.',
			tip: '💡 Порада: через @PremiumBot у веб-версії Telegram можна придбати зірки за вигіднішою ціною.',
			processing: 'Обробка...',
			payTon: (amount) => `Оплатити ${amount} TON`,
			payStars: (stars) => `Оплатити ${stars} ⭐`,
			statuses: {
			  pending: 'Ініціалізація платежу...',
			  confirming: 'Очікування підтвердження...',
			  confirmed: '✅ Платіж підтверджено!',
			  sent: '📤 Інформацію надіслано на сервер',
			  timeout: '⏰ Час очікування минув',
			  error: '❌ Помилка платежу',
			},
			buy: 'Купити',
			google_play_error: 'Помилка під час оплати через Google Play.',

			  confirm: "Підтвердити",
			  ok: "OK",
			  initErrorTitle: "Помилка",
			  initError: "Не вдалося ініціалізувати TON Connect. Перезапустіть застосунок.",
			  confirmStars: (price, name) => `Оплатити ${price} ⭐ за "${name}"?`,
			  processing: "Обробка...",
			  error: "Помилка",
			  sentTitle: "Транзакцію надіслано",
			  sentDesc: "Дякуємо за покупку. Очікуйте підтвердження протягом 15 хвилин.",
			  waitTelegram: "Ви отримаєте сповіщення в Telegram боті.",
			  starsError: "Помилка під час створення інвойсу.",
			  tonError: "Не вдалося надіслати TON. Спробуйте пізніше.",
		
		  }	
	  }  
};


export const getTranslations = (lang = "en") => {
  return translations[lang] || translations.en;
};
